import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from 'views/Main'
Vue.use(VueRouter)

const routes = [
  {
    path: '',
    redirect: 'main'
  },
  {
    path: '/main',
    component:Main,
    children: [
      {
        path: '',
        redirect: 'index',
        meta:{
          title:''
        }
      },
      {
        path: 'index',
        name:'index',
        component: () => import('views/computer/index/Index'),
        meta:{
          title:'广西沧龙科技有限公司'
        }
      },
      {
        path: 'product',
        name:'product',
        component: () => import('views/computer/product/Index'),
        meta:{
          title:'关于产品'
        }
      },
      {
        path: 'detail',
        name:'detail',
        component: () => import('views/computer/product/Detail'),
        meta:{
          title:'关于产品详情'
        }
      },
      {
        path: 'trade',
        name:'trade',
        component: () => import('views/computer/trade/Index'),
        meta:{
          title:'行业应用'
        }
      },
      {
        path: 'tradedetail',
        name:'tradedetail',
        component: () => import('views/computer/trade/Detail'),
        meta:{
          title:'行业应用详情'
        }
      },
      {
        path: 'news',
        name:'news',
        component: () => import('views/computer/news/Index'),
        meta:{
          title:'新闻中心'
        }
      },
      {
        path: 'newsdetail',
        name:'newsdetail',
        component: () => import('views/computer/news/Detail'),
        meta:{
          title:'新闻详情'
        }
      },
      {
        path: 'about',
        name:'about',
        component: () => import('views/computer/about/Index'),
        meta:{
          title:'关于我们'
        }
      },
      {
        path: 'contact',
        name:'contact',
        component: () => import('views/computer/contact/Index'),
        meta:{
          title:'联系我们'
        }
      },
      {
        path: 'consult',
        name:'consult',
        component: () => import('views/computer/consult/Index'),
        meta:{
          title:'业务咨询'
        }
      },
      {
        path: 'hire',
        name:'hire',
        component: () => import('views/computer/hire/Index'),
        meta:{
          title:'人员招聘'
        }
      },
    ]
  },
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
